export const safeText = (val: any): string => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'string') return val;
    if (typeof val === 'object') {
        if (val.text && typeof val.text === 'string') return val.text;
        if (val.message && typeof val.message === 'string') return val.message;
        try {
            return JSON.stringify(val);
        } catch (e) {
            return '[Object]';
        }
    }
    return String(val);
}
